import { connect } from "react-redux";
import { I18n, Translate } from "react-redux-i18n";
import React, { Component } from "react";

import AICommandBox from "../../js/ai/AICommandBox";
import BackButton from "../../components/menus/BackButton";
import EatWithMeText from "../../components/EatWIthMeText";
import FlexGrowSpace from "../../widgets/FlexGrowSpace";
import CourierAppComponent from "./CourierAppComponent";
import UserImageButton from "../../components/icon-buttons/UserImageButton";
import { getMyImageUrl } from "../../js/auth";

class CourierApp extends Component {
  state = {};

  render() {
    return this.props.myStatus.restaurant_id ? (
      <div id="reservations" style={{ display: "flex", flexFlow: "column", flexGrow: 1, flexShrink: 1 }}>
        <div
          className="menuItemHeader"
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-start",
            height: "50px",
            alignItems: "center",
            fontSize: "18px",
            backgroundColor: "#FAF8EA",
            color: "#837B6C",
            paddingRight: "30px"
          }}
        >
          <EatWithMeText />
          <BackButton {...this.props} />
          <FlexGrowSpace />
          <div style={{ fontSize: "30px" }}>
            {this.props.myStatus.courierState === "OFF" ? (<span className="icon2-pause-outline">{I18n.t("admin_local.courier_off")}</span>) : null}
            {this.props.myStatus.courierState === "PAUSED" ? (<span className="icon2-pause-outline">{I18n.t("admin_local.courier_pause")}</span>) : null}
            {this.props.myStatus.courierState === "WAITING" ? (<span className="icon-hourglass">{I18n.t("admin_local.courier_ready")}</span>) : null}
            {this.props.myStatus.courierState === "DELIVERING" ? (<span className="i_takeaway">{I18n.t("admin_local.courier_delivering")}</span>) : null}
            {this.props.myStatus.courierState === "IDLE" ? (<span className="icon2-pause-outline">{I18n.t("admin_local.courier_pause")}</span>) : null}
          </div>
          <FlexGrowSpace />
          <span className="myTitle">
            {this.props.qrActionsOnly === true ? <Translate value="admin_local.courier" /> : <Translate value="admin_local.menus.orders" />}
          </span>
          <UserImageButton src={getMyImageUrl()} />
        </div>
        <CourierAppComponent qrActionsOnly={this.props.qrActionsOnly} />
        <AICommandBox />
      </div>
    ) : (
      ""
    );
  }
}

const mapStateToProps = (props, state) => {
  if (props.rootReducer.myStatus) {
    return {
      restaurant: props.rootReducer.restaurant,
      myStatus: props.rootReducer.myStatus,
      admin_local: props.rootReducer.admin_local,
      local: props.rootReducer.local,
      speechRecognitionOn: props.rootReducer.speechRecognitionOn,
      ai: props.rootReducer.ai,
      speechRecognitionAvailable: props.rootReducer.speechRecognitionAvailable
    };
  }
  return {};
};

export default connect(mapStateToProps)(CourierApp);
